



















































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {IMediaWrite} from "@/_objects/IMedia";
import Confirm from "@/components/Confirm.vue";
import {search} from "@/_services/user.services";
import {IUser, Role} from "@/_objects/IUser";
import {SNACK_ACTION} from "@/_store/snackbar";
import {store} from "@/_store";
import {create} from "@/_services/media.services";


@Component({
    components: {Confirm},
})
export default class MediaUpload extends Vue {
    public static getEmptyMediaWrite() {
        return { subid2: "", subid: "", description: "", publisher: {id: "", name: ""},
          blockZovio: false,
          blockPEC: false,
          brandingBEM: "",
          brandingPub: "",
          pell38K: false,
          pell6K: false,
          pellYear: false,
          type: "",
        };
    }
    @Prop({default: false}) private show!: string;
    private loading: boolean = false;
    private media: IMediaWrite = MediaUpload.getEmptyMediaWrite();
    private userList: IUser[] = [];
    private fileName: string = "";
    private publisherId: string = "";


    private close() {
        this.$emit('update:show', false);
    }


    private pickFile() {
        (this.$refs.uploadInput as any).click();
    }

    private async created() {
        if (this.$refs.form) {
            (this.$refs.form as any).reset();
        }
        this.publisherId = "";
        this.fileName = "";
        this.media = MediaUpload.getEmptyMediaWrite();
        this.loading = true;
        this.userList = await search();
        this.userList = this.userList.filter((u: IUser) => {
            return u.role === Role.PUBLISHER && u.isActive;
        });

        this.userList = this.userList.sort((a: IUser, b: IUser) => {
            const nameA = a.company.toUpperCase(); // ignore upper and lowercase
            const nameB = b.company.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }

            return 0;
        });
        this.loading = false;

    }

    @Watch('show')
    private onShowChanged() {
        this.media = MediaUpload.getEmptyMediaWrite();
        this.fileName = "";
        this.publisherId = "";
    }

    private onFilePicked(e: any) {
        const file = e.target.files[0];

        if (!file) {
            this.media.file = undefined;
            return;
        }
        this.fileName = file.name;
        this.getBase64(file);
    }

    private getBase64(file: File) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
           this.media.file = {
               base64: reader.result as string,
               ext: '.' + file.name.split('.').pop(),
               type: file.type,
           };
           this.media.file.ext = this.media.file.ext.toLowerCase();
        };
    }

    private async upload() {

        if (!this.fileName) {
            this.media.file = undefined;
        }
        if (this.media.url && this.media.file || (!this.media.url && !this.media.file)) {
            store.dispatch(SNACK_ACTION.ERROR, `Please select either File or Url, not both.`);
            return;
        }

        if (!this.publisherId) {
            store.dispatch(SNACK_ACTION.ERROR, `Please select a publisher.`);
            return;
        }

        const pub = this.userList.find((u: IUser) => {
            return u.id === this.publisherId;
        });

        if (pub) {
            this.media.publisher = {id: pub.id, name: pub.company};
        }

        this.loading = true;
        try {
            const newCreative = await create(this.media);
            if (newCreative) {
                store.dispatch(SNACK_ACTION.SUCCESS, `<b>Creative uploaded successfully.`);
                this.$emit('update:show', false);
                this.$emit('success', true);
            }
        } catch (err) {
            // Do nothing

        }
        this.loading = false;
    }

    private filterPubs(item: IUser, queryText: string) {
        return (item.company + " " + item.last + " " + item.first).toLowerCase().indexOf(queryText.toLowerCase()) > -1;
    }

}
